'use client';

import { createContext, useContext, type ReactNode } from 'react';
import type { AccessCheckResponse } from '@/lib/meta/abraUserClient';

const FAIL_OPEN_DEFAULT: AccessCheckResponse = {
  is_geogated: false,
  is_age_locked: false,
  is_integrity_gated: false,
  is_crawler: false,
  is_employee_or_test_user: false,
};

const AccessCheckContext = createContext<AccessCheckResponse>(FAIL_OPEN_DEFAULT);

interface AccessCheckProviderProps {
  children: ReactNode;
  value?: AccessCheckResponse;
}

/**
 * Provides the server-side access check result to client components.
 * Fail-open: defaults to all flags false if no value is provided.
 */
export function AccessCheckProvider({ children, value }: AccessCheckProviderProps) {
  return (
    <AccessCheckContext.Provider value={value ?? FAIL_OPEN_DEFAULT}>
      {children}
    </AccessCheckContext.Provider>
  );
}

/**
 * Hook to access the access check result (geo-gating, age-lock, etc.).
 */
export function useAccessCheck(): AccessCheckResponse {
  return useContext(AccessCheckContext);
}
